import { TrendingDown, TrendingUp } from "@mui/icons-material";

type ImprovementIconProps = {
    value: number;
    color?: string;
};

export const ImprovementIcon = ({ value, color }: ImprovementIconProps) => {
    if (value > 0) return <TrendingUp sx={{ color }} />;
    if (value < 0) return <TrendingDown sx={{ color }} />;
    return null;
};
